
// External libraries
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io"

// Components
import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from "../../ui-elements"
import { POICategories, POICatsState, selPOICatState } from "../../states";
import { useRecoilValue } from "recoil";

interface POIListItemProps {
    type: keyof selPOICatState
    category: POICatsState
    selCB: number | null;
    selTempCats: selPOICatState;
    updateTempCatList: (listName: keyof selPOICatState, list: number[]) => void;
    handleCategoryChange?: (categoryKey: number) => void;
}

export const POICategoryListItem: React.FC<POIListItemProps> = ({ type, category, selCB, selTempCats, updateTempCatList, handleCategoryChange }) => {
    const poiCategories = useRecoilValue(POICategories);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        const value = Number(event.target.value);
        const isChecked = event.target.checked;

        let updatedList = [...selTempCats[type]];

        const subCategories = category.sub_categories?.map(subCat => subCat.key) || [];

        if (type === 'category') {
            // For category: add/remove the parent and its children
            if (isChecked) {
                // Add the parent and all subcategories
                updatedList = [...new Set([...updatedList, value])];

                // Ensure all subcategories are explicitly checked
                const updatedSubCategories = [...new Set([...selTempCats.subcategory, ...subCategories])];
                updateTempCatList('subcategory', updatedSubCategories);
            } else {
                // Remove the parent and all subcategories
                updatedList = updatedList.filter(item => item !== value);

                // Ensure all subcategories are explicitly unchecked
                const updatedSubCategories = selTempCats.subcategory.filter(item => !subCategories.includes(item));
                updateTempCatList('subcategory', updatedSubCategories);
            }
        } else if (type === 'subcategory') {
            // For subcategory: add/remove the child
            if (isChecked) {
                updatedList.push(value);

                // Ensure the parent is also selected if not already
                const parentCat = poiCategories.find(cat => cat.sub_categories?.some(subCat => subCat.key === value));
                if (parentCat && !selTempCats.category.includes(parentCat.key)) {
                    updateTempCatList('category', [...selTempCats.category, parentCat.key]);
                }
            } else {
                updatedList = updatedList.filter(item => item !== value); // Remove child

                // Check if all children are unchecked, and uncheck the parent if so
                const parentCat = poiCategories.find(cat => cat.sub_categories?.some(subCat => subCat.key === value));
                if (parentCat) {
                    const parentChildrenKeys = parentCat.sub_categories?.map(subCat => subCat.key) || [];
                    const areAllChildrenUnchecked = parentChildrenKeys.every(key => !updatedList.includes(key));
                    if (areAllChildrenUnchecked) {
                        updateTempCatList('category', selTempCats.category.filter(item => item !== parentCat.key));
                    }
                }
            }
        }

        // Update the state with the modified list
        updateTempCatList(type, updatedList);
    };

    const getSelSubCatsCount = (selSubCats: number[], subCats: any) => {
        return subCats.filter((item: any) => selSubCats.includes(item.key))?.length || 0;
    }

    console.log("CCCCCCC",category)

    return (
        <div className="d-flex justify-content-start align-items-center padding-top-bottom-2">
            <div className="width-10 d-flex justify-content-start align-items-center">
                <input
                    className=""
                    type="checkbox"
                    value={category.key}
                    checked={selTempCats[type].includes(category.key)}
                    onChange={(event) => handleChange(event)}
                />
            </div>

            {category.sub_categories ?
                <div className="width-90 d-flex justify-content-between align-items-center" onClick={() => handleCategoryChange && handleCategoryChange(category.key)} >
                    <Heading
                        title={`${category.name} (${getSelSubCatsCount(selTempCats.subcategory, category.sub_categories)}/${category.sub_categories.length})`}
                        colour={TypographyColor.secondary}
                        type={TypographyType.h6}
                        classname='m-0 p-0 text-start'
                    />
                    {(selCB === category.key ? <IoIosArrowUp className="icon-gray-0 fs-12" onClick={() => handleCategoryChange && handleCategoryChange(category.key)} /> : <IoIosArrowDown className="icon-gray-0 fs-12" />)}
                </div>
                :
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname="m-0 p-0 padding-left-2"
                >
                    {category.name}{category.count !== undefined ? ` (${category.count})` : ''}
                </Body>
            }
        </div>
    )
}